import { TmcContextService } from 'src/tmc-common/services/tmc-context.service';
import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { ContextChange, WidgetStyle } from '@sdbn/appclient';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { TranslationService } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/appclient';
import { YardAdministrationService } from '../yard-administration.service';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { StructureSelectionService } from 'src/tmc-yard/common/structure-selection/structure-selection-dialog/structure-selection-dialog-service';
import { StructureSelection } from 'src/tmc-yard/common/structure-selection/structure-selection.model';

@Component({
  selector: 'app-yard-administration',
  templateUrl: './yard-administration.component.html',
  styleUrls: ['./yard-administration.component.scss']
})
export class YardAdministrationComponent extends AbstractWidgetComponent implements OnInit {

  responseMessages: ResponseMessage[];

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService,
    private yardAdministrationService: YardAdministrationService,
    private dialog: MatDialog,
    private structureSelectionService: StructureSelectionService
  ) {
    super();
  }

  ngOnInit() {
  }

  public triggerYardClientsReload(): void {
    this.responseMessages = [];

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        titleKey: 'tmc-yard.widgets.yard-administration.reload-yard-clients.confirm-dialog.title',
        messageKey: 'tmc-yard.widgets.yard-administration.reload-yard-clients.confirm-dialog.message',
        confirm: () => {
          this.yardAdministrationService.triggerYardClientsReload().subscribe(
            response => {
              this.responseMessages = response.responseMessages;
            }
          );
        }
      }
    });
  }

  public createEmergencyPrintout() {
    this.yardAdministrationService.emergencyCall(this.translationService.language);
  }

  public exportConfiguration() {
    this.yardAdministrationService.exportConfiguration(this.tmcContextService.getYardKey())
  }

  public cleanTransports() {
    this.responseMessages = [];

    this.dialog.open(ConfirmDialogComponent, {
      data: {
        titleKey: 'tmc-yard.widgets.yard-administration.clean-transports.confirm-dialog.title',
        messageKey: 'tmc-yard.widgets.yard-administration.clean-transports.confirm-dialog.message',
        confirm: () => {
          this.yardAdministrationService.cleanTransports().subscribe(
            response => {
              this.responseMessages = response.responseMessages;
            }
          );
        }
      }
    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  testStructureSelectionDialog() {
    this.structureSelectionService.selectStationSetOrStation(new StructureSelection()).subscribe(
      value => {
        console.log('selection dialog result is', value);
      }
    );
  }

  getStyle() {
    return WidgetStyle.transparent;
  }

}
